"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersTriggerSources = void 0;
exports.UsersTriggerSources = {
    verifyEmail: 'CustomMessage_SignUp',
    afterVerification: 'PostConfirmation_ConfirmSignUp'
};
//# sourceMappingURL=events.js.map